import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Collapse,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function NestedListItem(props) {
  const [open, setOpen] = useState(props.item.defaultOpen ?? false);
  const location = useLocation();

  // Sync the expander with the active route: open while a child route is
  // active (props.isSelected is true), collapse when navigating away.
  // We also depend on location.pathname so navigations between routes
  // that are *both* outside this group (e.g. user manually opened Forms
  // while on Library, then clicked Approvals) still trigger a sync —
  // otherwise isSelected stays false→false and the effect never fires.
  useEffect(() => {
    setOpen(props.isSelected);
  }, [props.isSelected, location.pathname]);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <ListItem key={props.index} disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        key={props.index}
        data-testid={props.item.testId}
        component="a" //need to use an anchor tag for this to render properly.  Omitting the href will cause a button to not render properly.
        selected={props.isSelected}
        onClick={handleClick}
        sx={{
          '&.Mui-selected': {
            borderLeft: '3px solid #1976d2',
            borderLeftWidth: '2px',
            '& .MuiListItemText-primary': {
              fontWeight: 700,
            },
          },
          '&.Mui-focusVisible': {
            backgroundColor: '#1c8cfd',
          },
          ':hover': {
            backgroundColor: '#4da6ff',
          },
        }}
      >
        <ListItemIcon className="MuiSvgIcon-root">
          {props.item.icon}
        </ListItemIcon>
        <ListItemText
          primary={props.item.text}
          slotProps={{
            primary: {
              noWrap: true,
              title: props.item.text,
            },
          }}
        />
        {!props.isAdmin ? (
          open ? (
            <ExpandLess />
          ) : (
            <ExpandMore />
          )
        ) : open ? (
          <ExpandMore />
        ) : (
          <ExpandLess />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {props.children}
      </Collapse>
    </ListItem>
  );
}
